<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    :parentStoreName="parentStoreName"
    :parentUrlKey="parentUrlKey"
    :submit="submit"
    :status="status"
    labelBack="Atrás"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row justify="center">
        <v-col cols="8">
          <v-row>
            <v-col>
              <ValidationProvider
                ref="color"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="data.color"
                  label="Color"
                  prepend-inner-icon="fas fa-file"
                  ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider
                ref="patent"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="data.patent"
                  label="Patente"
                  prepend-inner-icon="fas fa-file"
                  ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <ValidationProvider ref="car_brand_id" rules="required" v-slot="{ errors }">
                <v-select @change="updateModels()" :error-messages="errors" v-model="data.car_brand_id" label="Marcas" :items="brands"
                  item-text="name" item-value="id">
                  <template slot="no-data">
                    <v-alert :value="true"> There is no info to show </v-alert>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider ref="car_model_id" rules="required" v-slot="{ errors }">
                <v-select @change="changeModels(data.car_model_id)" :error-messages="errors" v-model="data.car_model_id" label="Modelos" :items="models"
                  :disabled="!can_select_model" item-text="name" item-value="id">
                  <template slot="no-data">
                    <v-alert :value="true"> There is no info to show </v-alert>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>            
            <v-col>
              <ValidationProvider ref="verified" rules="" v-slot="{ errors }">
                <v-checkbox
                  :error-messages="errors"
                  label="Verified"
                  v-model.number="data.verified"
                >
                </v-checkbox>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
                <v-img
                  class="mx-auto"
                  :src="img_car_model"
                  width="200"
                ></v-img>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
  import {ValidationProvider, ValidationObserver} from "vee-validate";
  import {mapState} from 'vuex';
  import Upload from "@/components/Upload";
  import CrudForm from "@/components/Crud/CrudForm";
  import CrudFormMixin from '@/mixins/crud_form';
  import GoogleMapLoader from "@/components/maps/GoogleMapLoader";

  export default {
    mixins: [CrudFormMixin],
    components: {ValidationProvider, ValidationObserver, CrudForm, GoogleMapLoader,Upload},
    computed: {
      ...mapState({
        status: state => state.Cars.status,
        brands: (state) => state.Car_brands.list,
        models: (state) => state.Car_models.list,
        colors: (state) => state.Car_colors.list,
      })
    },
    async created() {
      const self = this;
      self.$store.dispatch("Car_brands/getListAll", { show_all: "enable" });

      let filters = {};

      if(this.$route.params.user_id) {
        this.data.user_id = this.$route.params.user_id
        filters.user_id = this.$route.params.user_id
      }
      if(this.$route.params.id) {
        
        await self.$store.dispatch('Cars/show',this.$route.params.id ).then(val => {
          this.data.car_brand_id = val.car_model.brand.id;
          this.data.car_model_id = val.car_model.id;
          this.img_car_model = val.car_model.car_picture;
          this.data.verified = val.verified
        });

        filters.user_id = this.$route.params.id
      }

      // await self.$store.dispatch('Cars/getListAll',filters);
    },
    data() {
      return {
        parentStoreName:"Users_scroll",
        parentUrlKey:"user_id",
        storeName: 'Cars',
        title: "Autos",
        show1:false,
        can_select_model: false,
        can_select_color: false,
        filteredAttributes: ["picture"],
        picture: "",
        data: {
          user_id: '',
          car_brand_id:'', 
          car_model_id:'',
          // car_color_id:'',
          patent: '',
          color: '',
          // picture: undefined,
        },
        car_models: [],
        img_car_model: "",
        verified: false,
      }
    },
    watch: {
      "data.car_brand_id"(val) {
        const self = this;
        self.can_select_model = true;

        if(val!== self.data.car_color_id){
          self.can_select_color = false;
          self.data.car_color_id = '';
        }

        self.$store
          .dispatch("Car_models/getListAll", {
            show_all: "enable",
            brand_id: val
          })
          .then(models => {
            this.car_models = models;
          });
      },
      "data.car_model_id"(val){
        const self =this;
        
        if(val!== self.data.car_color_id){
          self.can_select_color = true;
        }
      }
    },
    methods: {
      updateModels(){
        const self = this;
        self.data.model_id = "";
        self.img_car_model = "";
      },
      changeModels(val){
        const self = this;
        let model = self.car_models.filter(model => model.id == val);
        self.img_car_model = model[0].car_picture;
      },
      onSelectedPicture(file) {
        const self = this;
        this.data.picture = file;

        let fr = new FileReader();
        fr.onload = function () {
          self.picture = fr.result;
        };
        fr.onerror = function () {
          self.picture = '';
        };
        fr.readAsDataURL(this.data.picture);
      }
    }
  }
</script>
